export default __webpack_public_path__ + "static/media/locqpay-balance.8a2de837.png";